import React, { useState } from "react";
import {
  Stack,
  Menu,
  MenuItem,
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@mui/material";

const DropdownFilter = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const open = Boolean(anchorEl);

  const options = ["Option 1", "Option 2", "Option 3"];

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleToggle = (option) => {
    setSelectedOptions((prevSelected) =>
      prevSelected.includes(option)
        ? prevSelected.filter((item) => item !== option)
        : [...prevSelected, option]
    );
  };

  const handleClearAll = () => {
    setSelectedOptions([]);
  };

  return (
    <Stack>
      {/* Filter Button */}
      <Button
        variant="contained"
        onClick={handleClick}
        sx={{
          textTransform: "none",
          backgroundColor: "#f0f0f0",
          color: "black",
          "&:hover": { backgroundColor: "#e0e0e0" },
        }}
      >
        Filter
      </Button>

      {/* Dropdown Menu */}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{
          "& .MuiMenu-paper": {
            minWidth: "240px",
            width: { xl: "6%" },
            padding: "10px",
          },
        }}
      >
        <Typography
          sx={{
            fontWeight: "bold",
            marginBottom: "10px",
            textAlign: "center",
          }}
        >
          Filter
        </Typography>
        {/* Options with Checkboxes */}
        {options.map((option, index) => (
          <MenuItem
            key={index}
            disableRipple
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              padding: "0",
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={selectedOptions.includes(option)}
                  onChange={() => handleToggle(option)}
                />
              }
              label={option}
            />
          </MenuItem>
        ))}
        {/* Clear All Button */}
        <MenuItem
          onClick={handleClearAll}
          sx={{
            display: "flex",
            justifyContent: "center",
            marginTop: "10px",
            borderTop: "1px solid #7A7A7A",
            paddingTop: "10px",
          }}
        >
          <Button
            variant="outlined"
            color="error"
            size="small"
            sx={{ textTransform: "none" }}
          >
            Clear All
          </Button>
        </MenuItem>
      </Menu>
    </Stack>
  );
};

export default DropdownFilter;
